import { useSetRecoilState } from 'recoil'
import { modalState, modalCountState } from 'store/atom/modal-state-atom'

export default function ModalsConfig() {
  //Recoil 사용
  const setModalState = useSetRecoilState(modalState)
  const setModalCount = useSetRecoilState(modalCountState)

  const modalLockedElements = new Map()
  let modalIdCounter = 0

  // modal 창 켜져있는 상태에서 input/select 이벤트 버블링 방지
  const preventInteraction = (e) => {
    if (!document.body.classList.contains('modal-open')) return

    if (e.target.closest('.alert-window') || e.target.closest('.popup-window')) return

    e.preventDefault()
    e.stopPropagation()
  }

  const lockInputs = (modalId) => {
    const locked = new Set()

    document.querySelectorAll('input, textarea').forEach((el) => {
      if (!el.closest('.alert-window') && !el.hasAttribute('readonly')) {
        el.setAttribute('readonly', true)
        locked.add(el)
        if (document.activeElement === el) el.blur()
      }
    })

    document.querySelectorAll('select').forEach((el) => {
      if (!el.closest('.alert-window') && !el.hasAttribute('disabled')) {
        el.setAttribute('disabled', true)
        locked.add(el)
      }
    })

    modalLockedElements.set(modalId, locked)
  }

  const unlockInputs = (modalId) => {
    const locked = modalLockedElements.get(modalId)
    if (!locked) return

    locked.forEach((el) => {
      if (el.tagName === 'SELECT') el.removeAttribute('disabled')
      else el.removeAttribute('readonly')
    })

    modalLockedElements.delete(modalId)
  }

  const enableInteractionLock = () => {
    document.body.addEventListener('touchstart', preventInteraction, { passive: false })
    document.body.addEventListener('touchmove', preventInteraction, { passive: false })
    document.body.addEventListener('mousedown', preventInteraction)
  }

  const disableInteractionLock = () => {
    document.body.removeEventListener('touchstart', preventInteraction)
    document.body.removeEventListener('touchmove', preventInteraction)
    document.body.removeEventListener('mousedown', preventInteraction)
  }

  //Modal Open : Recoil Add Modal Component Props
  const open = (Component, props, ok, cancel) => {
    const modalProps = {
      id: ++modalIdCounter,
      modalComp: Component,
      props,
      ok,
      cancel,
    }

    setModalState((list) => {
      if (list.length === 0) {
        document.body.classList.add('modal-open')
        enableInteractionLock()
      }

      if (props?.componentName === 'AlertModal' || props?.componentName === 'ConfirmModal') lockInputs(modalProps.id)

      return [...list, modalProps]
    })
  }

  //Modal Close : Recoil Remove Modal Component Props
  const close = () => {
    setModalCount(null)
    setModalState((list) => {
      if (list.length === 0) return []

      const closingModal = list[list.length - 1]
      unlockInputs(closingModal.id)

      const temp = list.slice(0, list.length - 1)

      if (temp.length === 0) {
        document.body.classList.remove('modal-open')
        disableInteractionLock()
      }
      return temp
    })
  }

  //Modal Close  App: Recoil Remove Modal Component Props
  const closeAll = () => {
    document.body.classList.remove('modal-open')
    setModalCount(null)

    modalLockedElements.forEach((_, modalId) => {
      unlockInputs(modalId)
    })
    modalLockedElements.clear()

    disableInteractionLock()
    setModalState(() => [])
  }

  return {
    open,
    close,
    closeAll,
  }
}
